export default __webpack_public_path__ + "static/Pultruded-24f715b911acfd4127f205f9bffdd5a3.jpg";